/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Doc_Override_SuccessInputs */

const en_doc_override_success = /** @type {(inputs: Doc_Override_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Document type updated`)
};

const pt_br2_doc_override_success = /** @type {(inputs: Doc_Override_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo de documento atualizado`)
};

/**
* | output |
* | --- |
* | "Document type updated" |
*
* @param {Doc_Override_SuccessInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const doc_override_success = /** @type {((inputs?: Doc_Override_SuccessInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Doc_Override_SuccessInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_doc_override_success(inputs)
	return pt_br2_doc_override_success(inputs)
});